
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tarot-astrology-certification",
      function () {
        return require("private-next-pages/tarot-astrology-certification/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tarot-astrology-certification"])
      });
    }
  